<template>
    <div>
         <v-overlay :value="loader" absolute>
            Loading
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
           
            <v-card class="card2">
                <div class="text-center heading">
                    <v-row>
                        <v-tooltip bottom color="rgb(1, 127, 152)">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small @click="back()"><v-icon>mdi-close</v-icon></v-btn>
                            </template>
                            <span>
                                close
                            </span>
                        </v-tooltip>
                        <v-col cols="12" sm="5">
                            <strong> Course: {{courseinfo.crscode}}:{{courseinfo.crsname}} </strong>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <strong> Question Type :: {{qttype.name}} </strong>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <strong> Exam Type : {{examtype}} </strong>
                        </v-col>
                    </v-row>
                </div>
                <!-- {{questiondata}} -->
                <v-col class="mx-auto" v-for=" (item,index) in questiondata" :key="item[0].id">
                    <v-card class="box card-border" flat>
                        <template>
                            <div class="text-center">
                                <v-chip class="ma-2" color="success" outlined>
                                    Question Number {{ index + 1}}
                                </v-chip>
                                <v-chip class="ma-2" color="primary" outlined pill>
                                    Unit No {{ item[0].unito.name }}
                                </v-chip>

                                <v-chip class="ma-2" color="deep-purple accent-4" outlined>
                                    Difficulty Level : {{ item[0].difficulty.name }}
                                </v-chip>
                                <!-- <v-chip class="ma-2" color="indigo darken-3" outlined>
                                    Weightage : {{ item[0].weightage }}
                                </v-chip> -->
                            </div>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" >
                                    <span class="text"> 
                                        <strong>Problem Statement:</strong>
                                    </span>
                                </v-col>
                            </v-row>
                            <v-col class="col">
                                <v-row v-model="question_stmt" class="span-mr" v-if="item[0].question_stmt" v-html="item[0].question_stmt">
                                    {{item[0].question_stmt}}
                                </v-row>
                                <span v-if="item[0].quefile">
                                    <img class="imgs" :src="item[0].quefile" @click="zooimg(item[0].quefile) " />
                                    <!-- <v-btn color="primary" depressed @click="deleteFile(item[0].id,'question')">
                                        <v-icon left>{{ icons.mdiDelete }}</v-icon>
                                        Delete
                                    </v-btn> -->
                                </span>
                            </v-col>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" >
                                    <span class="text">
                                        <strong>Options:</strong>
                                    </span>
                                </v-col>
                            </v-row>
                            <v-col class="col" v-for="(option) in item[1]" :key="option.option_name">
                                <v-col>
                                    <v-row>
                                        <span class="span-mr" v-if="item[0].quiz_off_id == 'false'">
                                            <v-icon color="red" @click="deletedialog_option(option.id)">mdi-delete-circle</v-icon>
                                        </span>
                                        <span class="span-mr" v-else>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="gray" v-bind="attrs" v-on="on">mdi-delete-circle</v-icon>
                                                </template>
                                                <span>
                                                    This Question Offer Can't Delete !!!
                                                </span>
                                            </v-tooltip>
                                        </span>
                                        <span class="span-mr"> {{option.option_name}} </span>
                                        <input class="radiospace" type="radio" v-if="option.iscorrect" :checked="option.id"  />
                                        <input type="radio" name="opt" class="radiospace" v-else v-model="opt_id" v-bind:value="option.id" disabled />
                                        <span class="span-mr" v-if="option.option_value" v-html="option.option_value">
                                            {{option.option_value}}
                                        </span>
                                    </v-row>
                                    <v-row>
                                        <span class="span-mr" v-if="option.answerfile">
                                            <img class="imgs" :src="option.answerfile" @click="zooimg(option.answerfile) " />
                                        </span>
                                    </v-row>
                                </v-col>
                            </v-col>
                        </template>
                        <v-card-actions>
                            <v-row>
                                    <v-col cols="12" sm="5" lg="5">
                                            <span v-if="item[0].isapprove">
                                                <v-btn outlined rounded class="ma-2 button" @click="updateisapprove(item[0].id)">Approve <v-icon color="black">mdi mdi-checkbox-marked</v-icon> </v-btn>
                                            </span>
                                            <span v-else>
                                                <v-btn outlined rounded class="ma-2 button" @click="updateisapprove(item[0].id)">Approve <v-icon color="black">mdi mdi-checkbox-blank-outline</v-icon> </v-btn>
                                            </span>
                                    </v-col>
                                    <v-col cols="12" sm="5" lg="5">
                                        
                                        <v-autocomplete :items="difficulty_info_list" class="mr-2 pt-2" dense item-text="name" v-model.trim="item[0].difficulty" label="Select Difficulty Level" return-object @change="changedifflevel(item[0].id,item[0].difficulty)"
                                        ></v-autocomplete>
                                    </v-col>
                            </v-row>
                            
                            <v-col cols="12" sm="3" lg="3">
                                <v-btn class="button" text @click="editQuestion(item[0].id)">
                                    <v-icon class="edit-v-icon mr-2" size="18">edit</v-icon>
                                    EDIT
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" lg="3">
                                <span v-if="item[0].quiz_off_id == 'false'">
                                    <v-btn class="button-cancel" @click="deletedialog(item[0].id)"> Delete<v-icon color="red">mdi-delete-circle</v-icon> </v-btn>
                                </span>
                                <span v-else>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn outlined rounded class="ma-2" color="gray" v-bind="attrs" v-on="on"> Delete<v-icon color="gray">mdi-delete-circle</v-icon> </v-btn>
                                        </template>
                                        <span>
                                            This Question Offer Can't Delete !!!
                                        </span>
                                    </v-tooltip>
                                </span>
                            </v-col>
                            
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
            <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Image Pre-View</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <img class="rounded w-100 d-block imgs-preview" :src="img_url" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog_zooimg = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_delete" persistent max-width="400px">
                <v-card>
                    <v-container>
                        <input type="hidden" v-model="deleteItem.delete_id" />
                        <h3><strong>Are you sure you want Delete this Question???</strong></h3>
                        <v-row justify="center">
                            <v-btn class="button-cancel mr-2" @click="dialog_delete = false">No</v-btn>
                            <v-btn class="button" @click="deletequestion()">Yes</v-btn>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_delete_option" persistent max-width="400px">
                <v-card>
                    <v-container>
                        <input type="hidden" v-model="deleteItem.delete_id" />
                        <h3><strong>Are you sure you want Delete this Option???</strong></h3>
                        <v-row justify="center">
                            <v-btn class="button-cancel mr-2" @click="dialog_delete_option = false">No</v-btn>
                            <v-btn class="button" text @click="deleteoption()">Yes</v-btn>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { mdiAccount, mdiPencil, mdiShareVariant, mdiDelete } from "@mdi/js";
    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data: () => ({
            
            icons: {
                mdiAccount,
                mdiPencil,
                mdiShareVariant,
                mdiDelete,
            },
            loader: false,
            snackbar_msg: "",
            dialog_zooimg: false,
            img_url: null,
            selected: "",
            qno: "",
            snackbar: false,
            difficultylevel:"",
            difficulty_info_list: null,
            opt_id: null,
            color: "",
            org: null,
            dialog: false,
            save_btn_load: false,
            question_stmt: "",
            photopreview: "",
            dialog_delete: false,
            dialog_delete_option: false,
            courseinfo: null,
            examtype: null,
            qttype: null,
            unit_list: null,
            diff_level_list: null,
            filea: null,
            picked: null,
            qfile: null,
            //
            questiondata: null,
            editedIndex: -1,

            deleteItem: {
                delete_id: "",
            },
            deleteItem_opt: {
                delete_id: "",
            },
            editedItem: {
                qno: "",
                unito: "",
                difficulty: "",
                question_stmt: "",
                quefile: "",
                question_attachment_file_name: "",
                isselfapproved: "",
            },
          
           
        
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Question" : "Edit Question";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        updated: function () {
            console.log("Inside updated");
            this.$nextTick().then(() => {
                if (window.MathJax) {
                    console.log("rendering mathjax");
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                }
            });
        },
        methods: {
            updateisapprove(item) {
                //alert(item)
                let formData = new FormData();
                formData.append("answer", item);
                axios
                    .post("/Qbank/updateIsApprove", formData)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4CAF50", "Updated Successfully.");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.onload();
                    });
            },
            deletedialog(item) {
                //alert(item)
                this.dialog_delete = true;
                this.deleteItem.delete_id = item;
            },
            deletedialog_option(item) {
                // alert(item)
                this.dialog_delete_option = true;
                this.deleteItem_opt.delete_id = item;
            },
            deleteoption() {
                // console.log(item);
                //  alert(item);
                let formData = new FormData();
                formData.append("option", this.deleteItem_opt.delete_id);
                axios
                    .post("/Qbank/deleteoption", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", res.data.status);
                            this.dialog_delete_option = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.onload();
                    });
            },
            deletequestion() {
                let formData = new FormData();
                formData.append("question", this.deleteItem.delete_id);
                axios
                    .post("/Qbank/deletequestion", formData)
                    .then((res) => {
                        // alert("in then")

                        if (res.data.flag == "YES") {
                            //  console.log(res.data.flag)
                            // alert("in if")
                            this.showSnackbar("#4CAF50", "Question Deleted Successfully.");
                            this.dialog_delete = false;
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        //  alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.onload();
                    });
            },
            back() {
                this.$router.push({ name: "papersetter-add-question-to-bank" });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            zooimg(url_img) {
                //alert("zooimg"+url_img)
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            editQuestion(item) {
                this.$router.push({ name: "papersetter-edit-question-to-bank", params: { que_id: item, courseinfo: this.courseinfo } });
            },
            changedifflevel(item,item2)
            {
                // alert(item)
                // alert(item2)
                const data = {
                    question : item,
                    difficulty_id : item2.id,
                };
                axios
                    .post("/Qbank/upadteDifficuiltyLevel", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Question Difficulty Level Updated Successfully.");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.onload();
                    });
                
            },
            closedialog() {
                this.selected = "2";
                (this.editedOptionc.ispresent = ""), (this.editedOptiond.ispresent = ""), (this.editedOptione.ispresent = "");

                this.dialog = false;
            },
            enableOption() {
                switch (this.selected) {
                    case "2":
                        (this.editedOptionc.ispresent = ""), (this.editedOptiond.ispresent = ""), (this.editedOptione.ispresent = "");
                        break;
                    case "3":
                        this.editedOptionc.ispresent = "present";
                        break;
                    case "4":
                        this.editedOptionc.ispresent = "present";
                        this.editedOptiond.ispresent = "present";
                        break;
                    case "5":
                        this.editedOptionc.ispresent = "present";
                        this.editedOptiond.ispresent = "present";
                        this.editedOptione.ispresent = "present";
                        break;
                }
            },
  

            onload() {
                
                this.loader = true;
                const data = {
                    crs_id: this.$store.getters.courseid,
                    qtypeid: this.$store.getters.qbankquestype,
                    questypeid: this.$store.getters.questype,
                    mess: "test",
                };
                axios
                    .post("/Qbank/viewQuestion", data)
                    .then((res) => {
                        this.org = res.data.org;
                        this.questiondata = res.data.question_list;
                        this.courseinfo = res.data.crsinfo;
                        this.qttype = res.data.questionType;
                        this.examtype = res.data.examType;
                        this.unit_list = res.data.unitno;
                       // this.diff_level_list = res.data.difficultylevel;
                        this.difficulty_info_list = res.data.difficultylevel;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                     .finally(() => {
                        this.loader = false
                    });
            },
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New" : "Edit";
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
        border: 2px solid rgb(195, 214, 218) !important;
        border-radius: 10px;
    }
    .span-mr {
        margin: 0.7rem !important;
        padding: 0%;
    }
    .span-mr1 {
        margin: 0.2rem !important;
        padding: 0%;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0%;
        width: 150px;
        cursor: zoom-in;
    }
    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0%;
        width: 80%;
    }
    .card-border {
        border: 3px solid hsla(190, 99%, 30%, 1) !important;
        border-radius: 15px;
        margin: 1rem !important;
        width: auto;
    }
    .col{
        padding: 0%;
    }
    .text
    {
        color: hsla(190, 99%, 30%, 1) !important;
    }
</style>
